<template>
  <div class="sect internet_product">
    <div class="i_sec_ttl"><h4>상품부터 천천히 둘러보고 싶다면?</h4></div>
    <div class="sec_cont">
      <div class="pro_filter">
        <div class="filter_inner">
          <div class="btn_refresh_cover">
            <button class="btn_refresh" @click="resetFilter">
              <img
                src="@/assets/front/images/v2/arrows/ar_refresh.svg"
                alt="새로고침"
              />
            </button>
          </div>
          <div class="btn_select_cover">
            <button class="btn_select" @click="openFilter('tab_0')">
              {{ filter.item[0] === 'internetNtv' ? '인터넷+TV' : '인터넷' }}
            </button>
            <button class="btn_select" @click="openFilter('tab_1')">
              인터넷 속도{{
                filter.speed[0] === 'ALL' ? '' : `(${filter.speed.length})`
              }}
            </button>
            <button class="btn_select" @click="openFilter('tab_2')">
              통신사{{
                filter.telecom[0] === 'ALL' ? '' : `(${filter.telecom.length})`
              }}
            </button>
            <button class="btn_select" @click="openFilter('tab_3')">
              가격대{{
                filter.price[0] === 'ALL' ? '' : `(${filter.price.length})`
              }}
            </button>
            <!-- <button class="btn_select">설치지역</button> -->
          </div>
        </div>
      </div>
      <div class="filter_box">
        <div class="toggle_sect">
          <p>우리동네 설치가능 보기</p>
          <div class="toggle_switch">
            <input
              type="checkbox"
              id="switch_01"
              v-model="selCoverage"
              true-value="Y"
              false-value="N"
            />
            <label class="pnt" for="switch_01" @click="selectCoverage"></label>
          </div>
        </div>
        <div class="toggle_sect">
          <p>찜한 상품</p>
          <div class="toggle_switch">
            <input
              type="checkbox"
              id="switch_02"
              v-model="selBookmark"
              true-value="Y"
              false-value="N"
            />
            <label class="pnt" for="switch_02" @click="selectBookmark"></label>
          </div>
        </div>
      </div>
      <!-- <div class="int_pro_txt">
            <P
              >퍼스에서 아래와 같은 조건으로 상품을 구매한 고객들은<br /><span
                >평균 50만 원</span
              >의 혜택을 받았어요!</P
            >
          </div> -->
      <div class="list_order">
        <p>총 {{ total }}개</p>
        <button class="btn_order" @click="openSortModal">
          {{ selectedSort.label }}
        </button>
      </div>
      <div v-if="ktPromotionView || helloPromotionView">
        <Swiper
          :options="swiperOptionPromotionBnr"
          ref="swiperOptionPromotionBnr"
          @click-slide="clickSlide"
        >
          <SwiperSlide v-for="(item, index) in centerBnr" :key="index">
            <div class="promo_kt_img">
              <img
                :src="require(`@/assets/front/images/banner/main/${item.img}`)"
                alt=""
              />
            </div>
          </SwiperSlide>
          <!-- <div class="swiper-pagination-popup" slot="pagination"></div> -->
        </Swiper>
      </div>
      <div class="int_pro_list">
        <ul class="int_pro_list_ul" v-if="total > 0">
          <InternetProduct
            v-for="(item, index) in list"
            :key="index"
            :item="item"
            @view="goItemView"
          />
        </ul>
        <ul v-else>
          <div class="empty_wrap">
            <div class="empty">
              <div class="msg">
                <div>
                  필터 검색 결과가 없습니다.<br />다른 옵션을 선택해 주세요!
                </div>
              </div>
            </div>
          </div>
        </ul>
        <div class="more_btn" v-if="total > 5 && list.length !== total">
          <button @click="viewMore">
            <span>더보기</span>
            <img src="@/assets/front/images/v2/arrows/ar_hash_down.svg" />
          </button>
        </div>
      </div>
    </div>
    <SortModal
      :value="selectedSort"
      :show="isSortModal"
      @close="closeSortModal"
    />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
// Import Swiper styles
import 'swiper/swiper.scss';
import InternetProduct from '@/front/customer/views/home/components/InternetProduct';
import SortModal from '@/front/customer/views/home/modal/InternetProductSortModal';

export default {
  name: 'InternetProducts',
  description: '인터넷 메인 - 인터넷 상품',
  props: {
    list: Array,
    total: Number,
    filter: Object,
    params: Object,
    isInternetCreate: {
      type: Boolean,
      default: true,
    },
    ktPromotionView: Boolean,
    helloPromotionView: Boolean,
    centerBnr: Array,
  },
  components: {
    InternetProduct,
    SortModal,
    Swiper,
    SwiperSlide,
  },
  data(props) {
    return {
      swiperOptionPromotionBnr: {
        loop: true,
        autoplay: props.centerBnr.length > 1,
        spaceBetween: 1,
        speed: 500,
        on: {
          slideChange: function() {
            //이벤트 또는 조건문으로 이용하면 된다.
            // console.log(this.autoplay);
          },
        },
      },
      selTv: props.params.selTv,
      selCoverage: props.params.selCoverage,
      selBookmark: props.params.selBookmark,
      isSortModal: false,
      selectedSort: { label: '낮은 가격 순', value: 'PRICE_ASC' },
    };
  },
  methods: {
    selectCoverage() {
      const selCoverage = this.selCoverage == 'Y' ? 'N' : 'Y';
      this.$emit('fetch', 'selCoverage', selCoverage);
    },
    selectBookmark() {
      const selBookmark = this.selBookmark == 'Y' ? 'N' : 'Y';
      this.$emit('fetch', 'selBookmark', selBookmark);
    },
    openSortModal() {
      this.isSortModal = true;
    },
    closeSortModal(val) {
      if (val) {
        this.selectedSort = val;
        this.$emit('fetch', 'orderType', val.value);
      }
      this.isSortModal = false;
    },
    viewMore() {
      this.$emit('more');
    },
    resetFilter() {
      this.selTv = 'Y';
      this.selCoverage = 'Y';
      this.selectedSort = { label: '낮은 가격 순', value: 'PRICE_ASC' };
      this.$emit('reset');
    },
    openFilter(selTab) {
      this.$emit('filter', selTab);
    },
    goItemView(item) {
      this.$emit('view', item);
    },
    clickSlide(index, reallyIndex) {
      console.log('index : ' + index + ' : reallyIndex : ' + reallyIndex);

      this.$emit(
        'goPromotionDetail',
        this.centerBnr[reallyIndex].linkName,
        this.centerBnr[reallyIndex].params,
      );
    },
  },
};
</script>
